import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  getAllMyTrips,
  getBookingDetails,
  getCreditNoteList,
  getTicketPDF,
  sendInvoiceEmailAndSMS,
  sendTicketEmailAndSMS,
} from "./services/mytrips.services";
import { IMyTripInitial } from "./mytripsModel";

const initialState: IMyTripInitial = {
  loading: false,
  CNLoading: false,
  ticketLoading: false,
  emailLoading: false,
  senInvoiceLoading: false,
  error: "",
  MytripsList: {
    upcommings: [],
    cancelled: [],
    completed: [],
    onprogress: [],
    failed: [],
  },
  BookinDetails: null,
  CNList: [],
};

const myTripsListSlice = createSlice({
  name: "mytrips",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllMyTrips.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllMyTrips.fulfilled, (state, action) => {
      state.loading = false;
      state.MytripsList = action.payload;
      state.error = "";
    });
    builder.addCase(getAllMyTrips.rejected, (state, action) => {
      state.loading = false;
      state.MytripsList = initialState.MytripsList;
      state.error = action.error.message || "Something went wrong";
    });

    // Booking Details API CALL oms/v1/booking-details

    builder.addCase(getBookingDetails.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getBookingDetails.fulfilled, (state, action) => {
      state.loading = false;
      state.BookinDetails = action.payload;
      state.error = "";
    });
    builder.addCase(getBookingDetails.rejected, (state, action) => {
      state.loading = false;
      state.BookinDetails = null;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getCreditNoteList.pending, (state) => {
      state.CNLoading = true;
      state.CNList = [];
    });
    builder.addCase(getCreditNoteList.fulfilled, (state, action) => {
      state.CNLoading = false;
      state.CNList = action.payload;
      state.error = "";
    });
    builder.addCase(getCreditNoteList.rejected, (state, action) => {
      state.CNLoading = false;
      state.CNList = [];
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getTicketPDF.pending, (state) => {
      state.ticketLoading = true;
    });
    builder.addCase(getTicketPDF.fulfilled, (state, action) => {
      state.ticketLoading = false;
      state.error = "";
    });
    builder.addCase(getTicketPDF.rejected, (state, action) => {
      state.ticketLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(sendTicketEmailAndSMS.pending, (state) => {
      state.emailLoading = true;
    });
    builder.addCase(sendTicketEmailAndSMS.fulfilled, (state, action) => {
      state.emailLoading = false;
      state.error = "";
    });
    builder.addCase(sendTicketEmailAndSMS.rejected, (state, action) => {
      state.emailLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(sendInvoiceEmailAndSMS.pending, (state) => {
      state.senInvoiceLoading = true;
    });
    builder.addCase(sendInvoiceEmailAndSMS.fulfilled, (state, action) => {
      state.senInvoiceLoading = false;
      state.error = "";
    });
    builder.addCase(sendInvoiceEmailAndSMS.rejected, (state, action) => {
      state.senInvoiceLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {} = myTripsListSlice.actions;
export default myTripsListSlice.reducer;
